// facets-custom.js
// Adapted for the new theme's <facets-form><form class="facets">...</form></facets-form> markup.
// The old theme had separate id="FacetFiltersForm" / id="FacetFiltersFormMobile" / sort forms
// with distinguishing IDs. This theme uses a single unnamed <form class="facets"> per
// <facets-form> instance (there may be more than one on the page, e.g. sidebar + drawer),
// and sort_by travels along as a hidden input rather than a separate live form.

document.addEventListener('DOMContentLoaded', function () {

    // MEGATREE_MULTITAG_MODIFICATION_START
    // Strict CSP blocks inline <script> execution, so the data that used to be set via
    // an inline script (window.ShopifyMegatree = {...}) is now passed as data-* attributes
    // on the <facets-form> element instead, and read here.
    (function initShopifyMegatree() {

        const source = document.querySelector('facets-form[data-megatree-url]');

        if (!source) return;

        let meta = {};
        let currentTags = [];

        try {
            meta = JSON.parse(source.dataset.megatreeMeta || '{}') || {};
        } catch (e) {
            console.error('MegaTree: failed to parse data-megatree-meta', e);
        }

        try {
            currentTags = JSON.parse(source.dataset.megatreeTags || '[]') || [];
        } catch (e) {
            console.error('MegaTree: failed to parse data-megatree-tags', e);
        }

        window.ShopifyMegatree = window.ShopifyMegatree || {};
        window.ShopifyMegatree.url = source.dataset.megatreeUrl || '';
        window.ShopifyMegatree.meta = meta;
        window.ShopifyMegatree.currentTags = currentTags;
    })();
    // MEGATREE_MULTITAG_MODIFICATION_END

    // MEGATREE_MULTITAG_MODIFICATION_START
    // Event delegation on document instead of binding once to the forms found at
    // DOMContentLoaded: if the theme's own facets-form custom element re-renders the
    // filter markup (AJAX filtering), a listener bound directly to the old nodes would
    // be lost. Delegation survives DOM replacement.
    document.addEventListener('click', function (event) {

        if (event.target.type !== 'checkbox') return;
        if (!window.ShopifyMegatree) return;

        const filterForm = event.target.closest('facets-form form.facets');

        if (!filterForm) return;

        const value = event.target.value;
        const name = event.target.name || '';

        const isSubcollection = name.startsWith('subcollection');
        const isMegatreeManaged = !!(window.ShopifyMegatree
            && window.ShopifyMegatree.meta
            && Object.prototype.hasOwnProperty.call(window.ShopifyMegatree.meta, value));

        // Only hijack navigation for MegaTree-managed tags/subcollections. Every other
        // filter (color, size, availability, price, etc.) is left alone so the theme's
        // native facets-form handling (auto-submit / AJAX update) works as normal.
        if (!isSubcollection && !isMegatreeManaged) return;

        event.preventDefault();
        event.stopPropagation();

        window.location.href = getRedirectPath(event, filterForm);
    });
    // MEGATREE_MULTITAG_MODIFICATION_END

    function getRedirectPath(event, filterForm) {

        let redirectPath = window.ShopifyMegatree.url;

        /* ----------------------------------------------------------------------------- */

        if (event.target.name.startsWith('subcollection')) {

            return `${redirectPath}/${event.target.value.replace(/\s+/g, "-").toLowerCase()}`;
        }

        /* ----------------------------------------------------------------------------- */

        if (event.target.name.startsWith('filter')) {

            const currentTags = window.ShopifyMegatree.currentTags || [];
            const currentTag = currentTags.join('+');
            const selectedTag = event.target.value;

            /* ----------------------------------------------------------------------------- */

            const inputTags = {};
            const inputFilters = {};

            filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {

                if (currentTags.includes(input.value)) {

                    if (window.ShopifyMegatree.meta[input.value]?.friendly_seo === '1') {

                        inputTags[input.value] = input.name;
                    } else {

                        inputFilters[input.value] = input.name;
                    }
                }
            });

            filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {

                if (!currentTags.includes(input.value)) {

                    if (window.ShopifyMegatree.meta[input.value]?.friendly_seo === '1') {

                        inputTags[input.value] = input.name;
                    } else {

                        inputFilters[input.value] = input.name;
                    }
                }
            });

            /* ----------------------------------------------------------------------------- */

            const multiTag = findMultiTag(Object.keys(inputTags));

            const searchParams = [];

            const sortBy = filterForm.querySelector('[name="sort_by"]')?.value;

            if (sortBy) {

                searchParams.push(`sort_by=${sortBy}`);
            }

            if (multiTag) {

                multiTag.tags.forEach(value => {

                    delete inputTags[value];
                });

                redirectPath = `${redirectPath}/${multiTag.tag.replace(/\s+/g, "-").toLowerCase()}`;

                if (Object.keys(inputTags).length > 0) {

                    Object.entries(inputTags).forEach(([key, value]) => {

                        searchParams.push(`${value}=${key}`);
                    });
                }

                if (Object.keys(inputFilters).length > 0) {

                    Object.entries(inputFilters).forEach(([key, value]) => {

                        searchParams.push(`${value}=${key}`);
                    });
                }
            } else {

                if (inputTags[currentTag] && currentTag === selectedTag) {

                    delete inputTags[currentTag];
                }

                if (Object.keys(inputTags).length > 0) {

                    let index = 0;

                    Object.entries(inputTags).forEach(([key, value]) => {

                        if (index === 0) {

                            redirectPath = `${redirectPath}/${key.replace(/\s+/g, "-").toLowerCase()}`;
                        } else {

                            inputFilters[key] = value;
                        }

                        index++;
                    });
                }

                if (Object.keys(inputFilters).length > 0) {

                    Object.entries(inputFilters).forEach(([key, value]) => {

                        searchParams.push(`${value}=${key}`);
                    });
                }
            }

            if (searchParams.length > 0) {

                redirectPath = `${redirectPath}?${searchParams.join('&')}`;
            }

            return redirectPath;
        }

        return redirectPath;
    }

    function findMultiTag(tags) {

        let bestMatch = null;
        let maxCount = -1;

        for (const [key, data] of Object.entries(window.ShopifyMegatree.meta)) {

            if (data.multi !== "1") continue;

            const isSubset = data.multi_tags.every(tag => tags.includes(tag));

            if (isSubset) {

                if (data.multi_tags.length > maxCount) {

                    maxCount = data.multi_tags.length;

                    bestMatch = { tag: key, tags: data.multi_tags };
                }
            }
        }

        return bestMatch;
    }

});
